import {
  CurrentUserWithAccountsDocument,
  CurrentUserWithAccountsQuery,
} from "@/apollo/types";
import { ApolloClient } from "@apollo/client";

export async function getAccountContext(
  slug: string,
  client: ApolloClient<object>,
) {
  // The accounts list (including each account's slug) is fetched by UserProvider
  // before the router renders, so this resolves from the Apollo cache without a
  // network round-trip.
  const { data } = await client.query<CurrentUserWithAccountsQuery>({
    query: CurrentUserWithAccountsDocument,
    context: {
      skipXAccountIdHeader: true,
    },
  });
  const accountId =
    data.current.accounts?.find((x) => x.slug === slug)?.id ?? "";
  return { accountId };
}
